package com.arena_web.ui.components.icons

import androidx.compose.runtime.Composable
import com.arena_web.ui.utils.s
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier

/**
 * The single canonical fill for every empty-state glyph across the app —
 * the dark navy used by the Following/Followers illustrations. Living here
 * keeps the colour discoverable from any empty-state composable, and dodges
 * the per-call inline definition that drifted on us before.
 */
const val EMPTY_STATE_GLYPH_COLOR = "#1A2E5E"

/**
 * Square monochrome glyph painted via CSS `mask` + flat background so the
 * caller can recolour any SVG icon from Kotlin. Empty-states default to
 * [EMPTY_STATE_GLYPH_COLOR]; pass a different [color] for one-off use.
 *
 * The `<img>` element doesn't propagate CSS variables into the SVG document,
 * so a tinted overlay can't be done by setting `color`/`filter`. The mask
 * trick uses the SVG as an alpha shape and fills the box with the requested
 * colour instead.
 */
@Composable
fun TintedGlyph(
    src: String,
    sizePx: Int,
    modifier: Modifier = Modifier,
    color: String = EMPTY_STATE_GLYPH_COLOR,
) {
    Box(
        modifier = modifier.styleModifier {
            property("width", s(sizePx))
            property("height", s(sizePx))
            property("background-color", color)
            property("-webkit-mask", "url('$src') no-repeat center / contain")
            property("mask", "url('$src') no-repeat center / contain")
        },
    )
}
